import { useQuery } from '@based/sdk/react'
import { PageSeo, type PageSeoProps } from '@app/components/core/seo/PageSeo'
import type { SeoMetaFields } from '@app/util/seo/seoMeta'

type StaticPageSeoProps = Omit<PageSeoProps, 'meta'> & {
  path: string
}

export const StaticPageSeo = ({ path, ...rest }: StaticPageSeoProps) => {
  const query = useQuery('view-page-seo', { path })
  const override = query.data as SeoMetaFields | undefined

  return <PageSeo meta={override} {...rest} />
}
